import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import Rentals from './pages/Rentals'
import Error from './pages/Error'
import Contact from './pages/Contact'

export default function App() {
  return (
    <div>
        <Header />
        <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/rentals' element={<Rentals />}/>
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/error' element={<Error/>}/>
        </Routes>
        <Footer />
    </div>
  )
}
